export const loading = {
  state: {
    loading: false
  },
  actions: {
    activate ({ commit }, payload) {
      commit('activate', payload)
    }
  },
  mutations: {
    activate (vuexState, payload) {
      vuexState.loading = payload
    }
  },
  getters: {}
}